let helper = new Object()

// приведение модели к нужному формату с помощью массива требуемых полей
helper.modelRequired = (required, model) => {
  if (!required) return model
  let modelNew = {}
  required.forEach(param => {
    modelNew[param] = model[param]
  })
  return modelNew
}

// приведение даты из запроса к модели для вью
helper.dataToView = (required, model, data) => {
  let dataNew = {}
  if (required) {
    required.forEach(param => {
      dataNew[param] = model[param]
      dataNew[param].value = data[param]
    })
  } else {
    for (let param in model) {
      dataNew[param] = model[param]
      dataNew[param].value = data[param]
    }
  };
  return dataNew
}

// приведение даты из вью к формату для запроса
helper.dataToRequest = (data, required) => {
  let dataNew = {}
  if (!required) {
    for (let param in data) {
      dataNew[param] = data[param].value
    };
  } else {
    required.forEach(param => {
      dataNew[param] = data[param].value
    })
  }
  return dataNew
}

export default helper
